<template>
  <div>
    <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../../assets/images/icons/home.png" class="full-logo"></a></div>
    <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
    <!-- This is the follow that happens when all but 1 question has been asked -->
    <FollowUpQuestion v-if="showFollowUpQuestion" @close="followUpQuestionClosed" />
    <div class="m-btn__nav" @click="showNav = true; closeInstruction(room.name)"><h4>Swap rooms</h4></div>
    <Instruction v-if="!roomInstruction" :room='room.name'></Instruction>
    <Navigation v-if="showNav" @close="showNav = false" :allQuestions='roomQuestionsLength' :questionsAnswered='roomQuestionsAnswered'></Navigation>
    <div id='pano' style="overflow:hidden;"></div>
    <div v-if="!roomQuestions[0].answered" id='question-1' class='q-btn'><a @click="selectQuestion(0)"><div class='q-btn-active'></div></a></div>
    <div v-else id='question-1' class='q-btn'><a @click="selectQuestion(0)"><div class='q-btn-inactive'></div></a></div>
    <div v-if="!roomQuestions[1].answered" id='question-2' class='q-btn'><a @click="selectQuestion(1)"><div class='q-btn-active'></div></a></div>
    <div v-else id='question-2' class='q-btn'><a @click="selectQuestion(1)"><div class='q-btn-inactive'></div></a></div>
    <div v-if="!roomQuestions[2].answered" id='question-3' class='q-btn'><a @click="selectQuestion(2)"><div class='q-btn-active'></div></a></div>
    <div v-else id='question-3' class='q-btn'><a @click="selectQuestion(2)"><div class='q-btn-inactive'></div></a></div>
    <MainFooter />
  </div>
</template>

<script>
import roomMixin from '../../mixins/roomMixin'
import Brand from '../../components/Brand'
import Navigation from '../../components/Navigation'
import Instruction from '../../components/Instruction'
import MainFooter from '../../components/MainFooter'
import ConfirmReset from '../../components/ConfirmReset'
import FollowUpQuestion from '../../components/FollowUpQuestion'
import Vue from 'vue'
var Marzipano = require('../../../node_modules/marzipano')
Vue.use(Marzipano)

export default {
  mixins: [roomMixin],
  components: {
    Brand,
    Navigation,
    Instruction,
    MainFooter,
    ConfirmReset,
    FollowUpQuestion
  },
  data () {
    return {
      roomId: 3
    }
  },
  methods: {
    setupRoom () {
    // Create viewer.
      var viewer = new Marzipano.Viewer(document.getElementById('pano'))
      // Create source.
      var source = Marzipano.ImageUrlSource.fromString(
        'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/tiles/kitchen/{z}/{f}/{y}/{x}.jpg',
        { cubeMapPreviewUrl: 'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/tiles/kitchen/preview.jpg' })

      // Create geometry.
      var geometry = new Marzipano.CubeGeometry([
        { tileSize: 256, size: 256, fallbackOnly: true },
        { size: 512, tileSize: 512 },
        { size: 1024, tileSize: 512 },
        { size: 2048, tileSize: 512 }
      ])
      // Create view.
      var limiter = Marzipano.RectilinearView.limit.traditional(2048, 120 * Math.PI / 180)
      var view = new Marzipano.RectilinearView(null, limiter)
      // Create scene.
      var scene = viewer.createScene({
        source: source,
        geometry: geometry,
        view: view,
        pinFirstLevel: true
      })
      // Autorotate function
      var autorotate = Marzipano.autorotate({
        yawSpeed: 0.1,
        targetPitch: 0,
        targetFov: Math.PI / 2
      })
      if (!!window.MSInputMethodContext && !!document.documentMode) {
        viewer.setIdleMovement(Infinity)
      } else {
        viewer.setIdleMovement(3000, autorotate)
      }
      viewer.startMovement(autorotate)
      // Display scene.
      scene.switchTo()
      scene.hotspotContainer().createHotspot(document.querySelector('#question-1'), { yaw: 4.88, pitch: 0.1 }) // fridge 4.88, pitch: 0.1
      scene.hotspotContainer().createHotspot(document.querySelector('#question-2'), { yaw: 5.88, pitch: 0.13 }) // table 4.88, pitch: 0.1
      scene.hotspotContainer().createHotspot(document.querySelector('#question-3'), { yaw: 4.3, pitch: 0.1 }) // cooker
    }
  },
  created: function () {
    this.updateNav()
  },
  mounted: function () {
    this.setupRoom()
  },
  name: 'Kitchen'
}
</script>

<style scoped lang="scss">
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  -ms-content-zooming: none;
}
#pano div {overflow:none;}
</style>



// WEBPACK FOOTER //
// src/views/rooms/Kitchen.vue